import { AmbientGlow, MagneticButton, ParticleField, ScrollReveal } from '@/components/design-system';
import { useAuth } from '@pooflabs/web';

export function ClosingCta() {
  const { user, login } = useAuth();

  return (
    <section className='relative overflow-hidden py-28 md:py-36'>
      <div className='absolute inset-0'>
        <ParticleField quantity={22} />
      </div>
      <AmbientGlow color='primary' size={520} position='top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' />

      <div className='container relative text-center'>
        <ScrollReveal>
          <h2 className='font-heading text-headline mx-auto max-w-xl text-foreground'>
            Every fragment recovered is worth counted.
          </h2>
          <p className='mx-auto mt-4 max-w-sm text-muted-foreground'>
            Connect your wallet and become part of the recovery network.
          </p>
          <div className='mt-9'>
            <MagneticButton onClick={() => !user && login()}>
              {user ? "You're Connected" : 'Connect & Join'}
            </MagneticButton>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default ClosingCta;
